(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxCallServiceButton', {
		bindings: {
			source: '@',
			model: '=?',
			sourceState: '@',
			label: '@',
			icon: '@',
			showLoading: '@',
			disabled: '=ngDisabled',
			runOnInit: '@?',
		},
		controller: MxCallServiceButtonCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-call-service-button/mx-call-service-button.html',
	});

	MxCallServiceButtonCtrl.$inject = ['$scope', '$timeout', 'mx.SolutionBuilderAgent.DataModelService'];

	function MxCallServiceButtonCtrl($scope, $timeout, dataModelService) {
		var vm = this;

		vm.$onInit = function () {
			vm.showLoading = vm.showLoading === 'true';
			vm.callServiceClick = callServiceClick;
			vm.loadingState = {
				Loading: 1,
				Default: 2,
			};

			vm.state = vm.loadingState.Default;

			if (vm.runOnInit === 'true') {
				callServiceClick();
			}
		};

		$scope.$watch('vm.sourceState', function () {
			if (sourceStateIs(mx.SolutionBuilderAgent.SourceLoadingStatus.LOADED) || sourceStateIs(mx.SolutionBuilderAgent.SourceLoadingStatus.REJECTED)) {
				$timeout(function () {
					vm.state = vm.loadingState.Default;
				}, 400);
			} else if (sourceStateIs(mx.SolutionBuilderAgent.SourceLoadingStatus.LOADING)) {
				vm.state = vm.loadingState.Loading;
			}
		});

		return vm;

		function callServiceClick(event) {
			if (event) {
				event.stopPropagation();
			}
			dataModelService.reloadSourceByPath(vm.source, vm.model, vm.model.Context.WidgetId);
		}

		function sourceStateIs(value) {
			return Number(vm.sourceState) === value;
		}
	}
})();
